import { render, staticRenderFns } from "./warranty.vue?vue&type=template&id=40b72dc4&"
import script from "./warranty.vue?vue&type=script&lang=ts&"
export * from "./warranty.vue?vue&type=script&lang=ts&"
import style0 from "./warranty.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports